import { clearSelection } from "action/garage/clearSelection";
import { closeModal } from "action/modal/closeModal";
import { openModal } from "action/modal/openModal";
import PAButton, { BUTTON_SIZE } from "component/design-system/buttons/PAButton";
import { useRouter } from "next/router";
import qs from "query-string";
import { useDispatch } from "react-redux";
import { getHrefAndPath } from "../../../util/url/getHrefAndPath";

function CustomTireSizeButton(props: any) {
  const {
    title, clearSelectedVehicle = false, currentSizes, style,
  } = props;

  const dispatch = useDispatch();
  const router = useRouter();

  function openTireSelectorModal() {
    dispatch(openModal("tier-size-calculator", {
      currentSizes,
      onSelectSize: (selectedTireSize: any) => {
        // clear all vehicle
        if (clearSelectedVehicle) {
          dispatch(clearSelection());
        }
        dispatch(closeModal());

        const queryString = qs.stringify({
          pathname: undefined,
          scroll: undefined,
          pageNumber: undefined,
        });
        const { href, asPath } = getHrefAndPath({ queryString, href: "/tires/[sizes]", asPath: `/tires/${selectedTireSize.replace("/", "-")}` });
        router.push(href, asPath)
          .then(() => window.scrollTo(0, 0));
      },
    }));
  }

  return (
    <PAButton
      type="button"
      onClick={openTireSelectorModal}
      style={style}
      size={BUTTON_SIZE.STANDARD}
    >
      {title}
    </PAButton>
  );
}

export default CustomTireSizeButton;
